import $ from 'jquery';
import { debounce } from 'throttle-debounce';

/**
 * Accordion plugin
 */
export default class Accordion {
    /**
     * @param $accordion Accordion container. Wrapper for trigger and content
     * @param options Additional options
     */
    constructor($accordion, options = {}) {
        this.options = $.extend(true, {
            classes: {
                stateOpened: 'accordions__item--opened',
                stateOpening: 'accordions__item--opening',
                container: 'accordions__item',
                trigger: 'accordions__trigger',
                content: 'accordions__content',
            },
            events: {
                onOpen: () => { },
                onClose: () => { },
            },
        }, options);

        if (!$accordion) {
            return;
        }

        this.$accordion = $accordion;
        this.$trigger = this.$accordion.querySelector('.' + this.options.classes.trigger);
        this.$content = this.$accordion.querySelector('.' + this.options.classes.content);

        this.init();
    }

    init() {
        if (this.$accordion.classList.contains(this.options.classes.stateOpened)) {
            this.open(this.$accordion, this.$content);
        }

        this.initAccordions();
    }

    initAccordions() {
        this.eventHandleToggle(this.$accordion);
        this.eventWindowResize(this.$accordion);
    }

    open($accordion, $content) {
        const height = $content.scrollHeight;
        const handler = () => {
            $accordion.classList.remove(this.options.classes.stateOpening);
            this.options.events.onOpen($accordion);
            $content.removeEventListener('transitionend', handler);
        };

        $accordion.classList.add(this.options.classes.stateOpening);
        $accordion.classList.add(this.options.classes.stateOpened);
        $content.style.maxHeight = height + 'px';

        $content.addEventListener('transitionend', handler);
    }

    close($accordion, $content) {
        $accordion.classList.remove(this.options.classes.stateOpened);
        $content.style.maxHeight = null;

        this.options.events.onClose($accordion);
    }

    resize($content) {
        const height = $content.scrollHeight;
        $content.style.maxHeight = height + 'px';
    }

    eventHandleToggle($accordion) {
        const handler = (e) => {
            e.preventDefault();

            if ($accordion.classList.contains(this.options.classes.stateOpened)) {
                this.close($accordion, this.$content);
            } else {
                this.open($accordion, this.$content);
            }
        }

        this.$trigger.addEventListener('click', handler);
    }

    eventWindowResize($accordion) {
        window.addEventListener('resize', debounce(200, () => {
            if ($accordion.classList.contains(this.options.classes.stateOpened)) {
                this.resize(this.$content);
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./front/treasurybond/js/common/accordion.js